export const companyDetailActionType = {
  create: 'create',
  update: 'update',
};
